module.exports = __webpack_public_path__ + "static/media/child.b0ca07b5.png";